import { render, staticRenderFns } from "./progressItems.vue?vue&type=template&id=550f47f2&scoped=true"
import script from "./progressItems.vue?vue&type=script&lang=js"
export * from "./progressItems.vue?vue&type=script&lang=js"
import style0 from "./progressItems.vue?vue&type=style&index=0&id=550f47f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f47f2",
  null
  
)

export default component.exports